module.exports = __webpack_public_path__ + "static/img/8-CN.65b1f1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/8-CN.jpg
// module id = R//W
// module chunks = 1